export default __webpack_public_path__ + "static/media/491.b8c3a877.svg";